module.exports = __webpack_public_path__ + "img/translationeditor_3.848b1ab8.jpg";